import classNames from 'classnames';

import {TypographySize, useTypography} from '../../../hooks/typography';
import {Avatar} from '../../../atoms/avatar';

import styles from './avatar-preview-title.module.css';

type Props = {
    userName: string;
    position?: string;
    avatarUrl?: string;
};

export const AvatarPreviewTitle = ({userName, position, avatarUrl}: Props) => {
    const [bodyLTrue, bodyM] = useTypography([
        {
            size: TypographySize.BodyXL,
            noDefaultColor: true,
        },
        {
            size: TypographySize.BodyL,
            noDefaultColor: true,
        },
    ]);

    return (
        <div className={styles.root}>
            <Avatar size={48} src={avatarUrl} username={userName} />
            <div className={styles.userInfo}>
                <span className={classNames(bodyLTrue, styles.textPrimary)}>{userName}</span>
                {position && <span className={classNames(bodyM, styles.textSecondary)}>{position}</span>}
            </div>
        </div>
    );
};
